/**
 * Mobile sticky ATC — the fixed bar appears only after the in-flow
 * add-to-cart has scrolled above the viewport. Matches the bottom-nav
 * breakpoint (≤989). Default state is inline (no FOUC).
 */
(function () {
  'use strict';

  var media = window.matchMedia('(max-width: 989px)');
  var observer = null;

  function clearHold() {
    var wraps = document.querySelectorAll('.product-form-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      wraps[i].style.minHeight = '';
      wraps[i].removeAttribute('data-atc-hold');
    }
  }

  function teardown() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    var pdp = document.querySelector('.fp-pdp');
    var form = pdp && pdp.querySelector('product-form.product-form');
    if (form) form.classList.add('is-inline');
    if (pdp) pdp.classList.remove('is-sticky-atc');
    document.body.classList.remove('egj-atc-sticky');
    clearHold();
  }

  function init() {
    teardown();
    if (!media.matches) return;
    if (!('IntersectionObserver' in window)) return;

    var pdp = document.querySelector('section.fp-pdp') || document.querySelector('.fp-pdp');
    var form =
      pdp &&
      pdp.querySelector('.product-form-wrapper:not(.disabled) product-form.product-form');
    var sentinel = pdp && pdp.querySelector('[data-egj-atc-sentinel]');
    if (!pdp || !form || !sentinel) return;

    var wrapper = form.closest('.product-form-wrapper');

    function applySticky(show) {
      if (wrapper) {
        if (show) {
          wrapper.classList.add('fp-atc-seen');
          if (!wrapper.getAttribute('data-atc-hold')) {
            wrapper.setAttribute('data-atc-hold', String(wrapper.offsetHeight));
          }
          wrapper.style.minHeight = wrapper.getAttribute('data-atc-hold') + 'px';
        } else {
          wrapper.style.minHeight = '';
          wrapper.removeAttribute('data-atc-hold');
        }
      }
      form.classList.toggle('is-inline', !show);
      pdp.classList.toggle('is-sticky-atc', show);
      document.body.classList.toggle('egj-atc-sticky', show);
    }

    applySticky(false);

    /* The root is stretched far below the viewport so "sentinel above the
       viewport" is its own intersection state. With a plain viewport root, a
       jump or fling that carries the sentinel from below to above in one frame
       never changes isIntersecting, and the bar never appears. */
    observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[entries.length - 1];
        var passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        applySticky(passed);
      },
      { threshold: 0, rootMargin: '0px 0px 100000px 0px' }
    );

    observer.observe(sentinel);
  }

  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', init);
  } else if (typeof media.addListener === 'function') {
    media.addListener(init);
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', teardown);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
